import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { getFinAssigned } from "http/UAM/userDashboardWidget.helper";
import NoDataChart from "pages/EntityMoreInformation/NoDataComponent";
import { decryptedValue } from "common/utility";

const FinAssigned = () => {
  const [data, setData] = useState(null);
  const [showStatus, setShowStatus] = useState(true)
  const user = decryptedValue(localStorage.getItem("user"));

  useEffect(() => {
    getFinAssigned().then((res) => {
      setShowStatus(res.data.length)
      setData(res.data)
    });
  }, [])
  const series = data ? data.map(item => ({
    name: `${item['assignedToUser.first_name']} ${item['assignedToUser.last_name']}`,
    data: parseInt(item.dealCount),
  })) : [];


  series.sort((a, b) => b.data - a.data);
  const top10Series = series.slice(0, 10);

  const options = {
    chart: {
      type: "bar",
      height: 500,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        endingShape: "rounded",
        columnWidth: '40%',
        borderRadius: 4,
        dataLabels: {
          position: "center",
        },
      },
    },
    colors: [
      function ({ dataPointIndex }) {
        switch (dataPointIndex) {
          case 0:
            return "#00c5dc";
          case 1:
            return "#f46a6a";
          case 2:
            return "#34c38f";
          case 3:
            return "#3f9ae5";
          case 4:
            return "#f1b44c";
          default:
            return "#0174BE";
        }
      },
    ],
    stroke: {
      width: 1,
      colors: ["#fff"],
    },
    xaxis: {
      title: {
        text: "Users",
      },
      categories: top10Series.map((financier) => financier.name),
    },
    yaxis: {
      title: {
        text: 'Deals'
      },
      labels: {
        formatter: function (value) {
          return Math.round(value);
        }
      }

    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " deals";
        },
      },
    },
  };

  return (
    <>
      {user.EntityAssignedFlag ? (
        <Card>
          {showStatus ? (
            <CardBody>
              <h4 className="card-title mb-2">
                {`Deal Assign to FI Users`}
              </h4>
              <ReactApexChart
                options={options}
                series={[{ name: "", data: top10Series.map((financier) => financier.data) }]}
                type="bar"
                height={314}
              />
            </CardBody>
          ) : (
            <NoDataChart title='No Information Found' subtitle="No Deal Assigned to FI User" />
          )}
        </Card>
      ) : (
        <div>
        </div>
      )}
    </>
  );

};

export default FinAssigned;
